module.exports = __webpack_public_path__ + "static/media/scissor-transparent.a529a531.png";